// @flow
import { useId, useRef } from 'react'
import * as React from 'react'

interface Props {
  color?: string
  className?: string
  size?: number
}
export const PersonAdd = ({
  color = 'white',
  className,
  size = 24
}: Props) => {
  const id = useId()

  return (
    <svg
      className={className}
      width={size} height={size} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id={`mask${id}`}
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' fill='#D9D9D9'/>
      </mask>
      <g mask={`url(#mask${id})`}>
        <path
          d='M18.875 13.7492C18.6583 13.7492 18.479 13.6782 18.337 13.5362C18.1957 13.3949 18.125 13.2159 18.125 12.9992V10.7492H15.875C15.6583 10.7492 15.4793 10.6782 15.338 10.5362C15.196 10.3949 15.125 10.2159 15.125 9.99922C15.125 9.78255 15.196 9.60322 15.338 9.46122C15.4793 9.31989 15.6583 9.24922 15.875 9.24922H18.125V6.99922C18.125 6.78255 18.1957 6.60355 18.337 6.46222C18.479 6.32022 18.6583 6.24922 18.875 6.24922C19.0917 6.24922 19.271 6.32022 19.413 6.46222C19.5543 6.60355 19.625 6.78255 19.625 6.99922V9.24922H21.875C22.0917 9.24922 22.271 9.31989 22.413 9.46122C22.5543 9.60322 22.625 9.78255 22.625 9.99922C22.625 10.2159 22.5543 10.3949 22.413 10.5362C22.271 10.6782 22.0917 10.7492 21.875 10.7492H19.625V12.9992C19.625 13.2159 19.5543 13.3949 19.413 13.5362C19.271 13.6782 19.0917 13.7492 18.875 13.7492ZM8.875 11.6992C7.90833 11.6992 7.08333 11.3532 6.4 10.6612C5.71667 9.96989 5.375 9.14922 5.375 8.19922C5.375 7.23255 5.71667 6.40755 6.4 5.72422C7.08333 5.04089 7.90833 4.69922 8.875 4.69922C9.84167 4.69922 10.6667 5.04089 11.35 5.72422C12.0333 6.40755 12.375 7.23255 12.375 8.19922C12.375 9.14922 12.0333 9.96989 11.35 10.6612C10.6667 11.3532 9.84167 11.6992 8.875 11.6992ZM2.275 19.2992C2.025 19.2992 1.81267 19.2159 1.638 19.0492C1.46267 18.8826 1.375 18.6659 1.375 18.3992V17.0742C1.375 16.5909 1.50833 16.1409 1.775 15.7242C2.04167 15.3076 2.4 14.9826 2.85 14.7492C3.83333 14.2659 4.82933 13.9032 5.838 13.6612C6.846 13.4199 7.85833 13.2992 8.875 13.2992C9.89167 13.2992 10.9043 13.4199 11.913 13.6612C12.921 13.9032 13.9167 14.2659 14.9 14.7492C15.35 14.9826 15.7083 15.3076 15.975 15.7242C16.2417 16.1409 16.375 16.5909 16.375 17.0742V18.3992C16.375 18.6659 16.2877 18.8826 16.113 19.0492C15.9377 19.2159 15.725 19.2992 15.475 19.2992H2.275ZM2.875 17.7992H14.875V17.0742C14.875 16.8742 14.8167 16.6909 14.7 16.5242C14.5833 16.3576 14.425 16.2159 14.225 16.0992C13.3583 15.6826 12.4793 15.3616 11.588 15.1362C10.696 14.9116 9.79167 14.7992 8.875 14.7992C7.95833 14.7992 7.054 14.9116 6.162 15.1362C5.27067 15.3616 4.39167 15.6826 3.525 16.0992C3.325 16.2159 3.16667 16.3576 3.05 16.5242C2.93333 16.6909 2.875 16.8742 2.875 17.0742V17.7992ZM8.875 10.1992C9.425 10.1992 9.896 10.0032 10.288 9.61122C10.6793 9.21989 10.875 8.74922 10.875 8.19922C10.875 7.64922 10.6793 7.17822 10.288 6.78622C9.896 6.39489 9.425 6.19922 8.875 6.19922C8.325 6.19922 7.85433 6.39489 7.463 6.78622C7.071 7.17822 6.875 7.64922 6.875 8.19922C6.875 8.74922 7.071 9.21989 7.463 9.61122C7.85433 10.0032 8.325 10.1992 8.875 10.1992Z'
          fill={color}
        />
      </g>
    </svg>
  )
}
